import { useAppDispatch } from '../../../../../../store/store';
import { useCallback } from 'react';
import { loadOrderAsyncAction } from '../../../../../../store/order/batchedDispatches';
import { useSelectCurrentOrderId } from '../../../../../../selectors/order/selectCurrentOrder';
import {
  executePartiesActions,
  partiesActionsSlice,
} from '../../../../../../store/order/orderData/partiesActionsSlice';
import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';
import { eApplicationActions, useApplicationContext } from '../../../../../../state';
import { convertToIUpdatePartiesForDeletion } from './convertToIUpdatePartiesForDeletion';

export const useOnDeleteParty = (party: IParty) => {
  const orderId = useSelectCurrentOrderId()!;
  const [, dispatchContext] = useApplicationContext();
  const dispatchRedux = useAppDispatch();
  const onDeleteParty = useCallback(() => {
    dispatchRedux(
      executePartiesActions({
        orderId,
        parties: convertToIUpdatePartiesForDeletion(party),
      })
    );
    dispatchRedux(loadOrderAsyncAction(orderId));
  }, [dispatchRedux, orderId, party]);
  const onClose = useCallback(
    () => dispatchContext({ type: eApplicationActions.FinishPartyChanges }),
    [dispatchContext]
  );
  const onCloseClick = useCallback(() => {
    dispatchRedux(partiesActionsSlice.actions.reset({}));
    dispatchRedux(loadOrderAsyncAction(orderId));
    onClose();
  }, [dispatchRedux, onClose, orderId]);
  return { onDeleteParty, onClose, onCloseClick };
};
